import { validateArticleImportBatches } from "./articleImportValidation";

export const isImportRowLocked = row => ["Saved", "SavedNotificationPending", "Uncertain"].includes(row.saveStatus);
export const isImportRowSaved = row => ["Saved", "SavedNotificationPending"].includes(row.saveStatus);

export async function saveArticleImportBatches(items, unitIds, { importId, showInPos, save, signal, onProgress, onBatchStart, onBatchResult } = {}) {
  const states = new Map();
  const byExcel = new Map(items.map(({ row }) => [row.excelRow, row]));
  const result = await validateArticleImportBatches(items, unitIds, { signal, onProgress,
    validate: async payload => {
      const rows = payload.map(value => {
        const row = byExcel.get(value.ExcelRow);
        return row.savePayload || { ...value, IsActive: row.resolved.active, ShowInPOS: showInPos,
          RowKey: `00000000-0000-4000-8000-${row.excelRow.toString(16).padStart(12, "0")}` };
      });
      rows.forEach(row => states.set(byExcel.get(row.ExcelRow).id, { status: "Uncertain", payload: row }));
      onBatchStart?.(rows);
      const response = await save({ ImportID: importId, Rows: rows }, signal);
      const expected = new Map(rows.map(row => [row.RowKey, row]));
      if (!Array.isArray(response?.Rows) || response.Rows.length !== rows.length || new Set(response.Rows.map(row => row.RowKey)).size !== rows.length ||
          response.Rows.some(row => expected.get(row.RowKey)?.ExcelRow !== row.ExcelRow ||
            !["Saved", "Failed", "Exists", "SavedNotificationPending"].includes(row.Status) || !Array.isArray(row.Issues) ||
            (["Saved", "SavedNotificationPending"].includes(row.Status) && (!Number.isInteger(row.ArticleID) || row.ArticleID <= 0)) ||
            (["Failed", "Exists"].includes(row.Status) && !row.Issues.length) || row.Issues.some(issue => issue.ExcelRow !== row.ExcelRow || typeof issue.Message !== "string")))
        throw new Error("Përgjigjja e ruajtjes nuk u verifikua. Rreshtat e kësaj pjese mbeten në pritje. Riprovimi kontrollon barkodat/emërtimet ekzistuese; konflikti nuk provon se cila tentativë e ruajti artikullin.");
      response.Rows.forEach(row => states.set(byExcel.get(row.ExcelRow).id, { status: row.Status, articleId: row.ArticleID, payload: expected.get(row.RowKey) }));
      onBatchResult?.(response.Rows);
      return { CheckedRows: rows.length, Issues: response.Rows.flatMap(row => row.Issues) };
    },
  });
  return { ...result, states };
}
